import {
  Box,
  Button,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  Divider as MuiDivider,
  FormControl as MuiFormControl,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
import Paper from "@mui/material/Paper";
// Custom Componenets
//Material UI Components and Functions
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Alert from "@mui/material/Alert";
import { spacing } from "@mui/system";
// Redux Components
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import {
  handleBillingProcessSubmission,
  updateBillingWizardBillInProgress,
  getAllUnsettledPropertyMeterReadingsByPropertyUUID
} from "../../../../modules/billing/api/actions";

const CenteredContent = styled.div`
  text-align: center;
`;

const Card = styled(MuiCard)(spacing);
const Divider = styled(MuiDivider)(spacing);
const FormControl = styled(MuiFormControl)(spacing);
const TextField = styled(MuiTextField)(spacing);

// Custom Styles for property selection drop down

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  table: {
    width: "100%",
  },
  selectedPropertyLocationLabel: {
    fontSize: 50,
    backgroundColor: "#fffffff",
    borderColor: "#fffffff",
  },
  loadingIconContainer: {
    display: "flex",
    alignItems: "center",
  },
  loadingIcon: {
    position: "relative",
    padding: "50px",
  },
  meterReadingSuccessColor: {
    color: "#1e4620",
  },
  meterReadingFailColor: {
    color: "#611a15",
  },
  meterReadingValue: {
    fontWeight: "bolder",
  },
}));

const MeterReadCheckForm = (props) => {
  const [billInProgress, setbillInProgress] = React.useState(
    props.billing.data.billInProgress
  );
  const classes = useStyles();
  // On initial page load methods:
  useEffect(() => {
    // Needs to get all unsettled reads associated with that property
  }, []);

  const updateCurrentBillingObjAndRunTrialBillsGeneration = () => {
    props.billing.data.billInProgress.currentStep = props.billing.data.billInProgress.currentStep + 1; // Sets the state to the next phase before saving
    props.billing.data.billInProgress.generateTrialBilling = true;
    props.updateBillingWizardBillInProgress(props.billing.data.billInProgress);
    props.handleBillingProcessSubmission(props.billing.data.billInProgress, true).then(() => {
      if (props.properties.data.property && props.properties.data.property.id) {
        props.getAllUnsettledPropertyMeterReadingsByPropertyUUID(props.properties.data.property.id);
      }
    });
  };
  const GetMeterReadingsStatus = () => {
    // Where the evaluation logic goes for checking if theres meter readings for each unit:
    if (props.billing.data.selectedProperty && props.billing.data.selectedProperty.id) {
      // If a selected property exists:
      // If theres an issue loading in the property object
      if (!props.billing.data.selectedProperty.meterReadings) {
        return (
          <Typography variant="h5">
            ERROR, Unable to load meter readings from datbase. Property object
            may not be valid
          </Typography>
        );
      }
      // If theres enough actual meter readings to move forward
      else if (
        props.billing.data.selectedProperty.meterReadings.actualCount >=
        props.billing.data.selectedProperty.totalUnits
      ) {
        return (
          <Typography variant="h5" className={classes.meterReadingSuccessColor}>
            {props.billing.data.selectedProperty.meterReadings.actualCount}{" "}
            Actual Unbilled Readings -{" "}
            {props.billing.data.selectedProperty.meterReadings.estimateCount}{" "}
            Estimate Unbilled Readings
          </Typography>
        );
      } else {
        return (
          <Typography variant="h5" className={classes.meterReadingFailColor}>
            {props.billing.data.selectedProperty.meterReadings.actualCount}{" "}
            Actual Unbilled Readings -{" "}
            {props.billing.data.selectedProperty.meterReadings.estimateCount}{" "}
            Estimate Unbilled Readings
          </Typography>
        );
      }
    }
  };
  return (
    <Card mb={6} elevation={3}>
      <CardContent>
        {/* Main Content (Just imports the properties meter data manager) */}
        {props.billing.isLoading ||
          props.billing.selectedPropertyIsLoading ||
          props.billing.selectedPropertyMetersAreLoading ? (
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 3,
            width: '100%',
            py: 4
          }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
              <CircularProgress />
            </Box>
          </Box>
        ) : props.billing.data.selectedProperty && props.billing.data.selectedProperty.id ? (
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            width: '100%',
            mb: 3
          }}>
            <Box sx={{ width: '100%' }}>
              <TableContainer component={Paper} sx={{ width: '100%' }}>
                <Table sx={{ width: '100%' }} aria-label="simple table">
                  <TableBody>
                    <TableRow>
                      <TableCell component="th" scope="row" sx={{ width: 'auto' }}>
                        <Typography variant="h5">
                          Current Property Meter Readings:
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ width: '100%' }}>
                        <Typography variant="h5">
                          <GetMeterReadingsStatus />
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        ) : (
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 3,
            width: '100%',
            py: 4
          }}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h5">No Property Data Loaded</Typography>
            </Box>
          </Box>
        )}
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          width: '100%',
          mt: 3
        }}>
          <Box sx={{ width: '100%' }}>
            {props.billing.data.billInProgress.errors.length > 0 && (
              <Alert severity="error">
                Cannot generate trial billing items until property issues are
                resolved.
              </Alert>
            )}
          </Box>
          {props.billing.data.billInProgress.errors.length == 0 &&
            !props.billing.isLoading && (
              <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 2,
                width: '100%',
                alignItems: 'stretch'
              }}>
                {/* Button 1 */}
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(50% - 8px)' } }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    onClick={updateCurrentBillingObjAndRunTrialBillsGeneration}
                    sx={{
                      py: 1.5,
                      fontSize: { xs: '0.875rem', sm: '0.9375rem' },
                      fontWeight: 'medium'
                    }}
                  >
                    Generate Trial Items For Billing Period
                  </Button>
                </Box>
                {/* Button 2 */}
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(50% - 8px)' } }}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => {
                      window.open("/meter-readings-upload");
                    }}
                    sx={{
                      py: 1.5,
                      fontSize: { xs: '0.875rem', sm: '0.9375rem' },
                      fontWeight: 'medium'
                    }}
                  >
                    Go To Uploads
                  </Button>
                </Box>
              </Box>
            )}
        </Box>
      </CardContent>
    </Card>
  );
};

// Component Properties
MeterReadCheckForm.propTypes = {
  // Store objects:
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  billing: PropTypes.object.isRequired,
  properties: PropTypes.object.isRequired,
  // Store object functions:
  updateBillingWizardBillInProgress: PropTypes.func.isRequired,
  handleBillingProcessSubmission: PropTypes.func.isRequired,
  getAllUnsettledPropertyMeterReadingsByPropertyUUID: PropTypes.func.isRequired,
  updateBillingWizardBillInProgress: PropTypes.func.isRequired,
};

// Component State
function MeterReadCheckFormState(state) {
  return {
    user: state.user,
    apl: state.apl,
    properties: state.properties,
    billing: state.billing,
  };
}
export default connect(MeterReadCheckFormState, {
  updateBillingWizardBillInProgress,
  handleBillingProcessSubmission,
  updateBillingWizardBillInProgress, getAllUnsettledPropertyMeterReadingsByPropertyUUID
})(MeterReadCheckForm);
